<template>
  <div class="pay-content">    
    <div class="bill-container">
      <h5>ТӨЛБӨР ТӨЛӨХ ДАНСНЫ ДУГААР</h5>
      <b-table class="table-success" :items="items" small></b-table>

      <h6>Дүн:</h6>
      <p class="bg-success text-white text-sm">
        20 000₮
      </p>

      <h6>Гүйлгээний утга:</h6>
      <p class="bg-success text-white text-sm">
        <em> "бүртгэлтэй утас" </em>
        {{ packet[0].text }}, Багц-{{ packet[1].text }}
      </p>
    </div>

    <p>
      <strong> Жич:</strong>
      Та сонгосон<strong>
        ангилал, багцаа
      </strong>
      сайтар шалгаад гүйлгээний утга дээр бүртгэлтэй утасны дугаар заавал
      бичнэ үү. Бид таны хүсэлтийг хүлээн авч багцыг нээж өгөх болно.
    </p>
    
  </div>
</template>
<script>
export default {
  props: ["reclass", "repacket"],
  data: () => {
    return {
      items: [
        {
          "Хүлээн авагч": "Искүүл ХХК",
          "Банкны нэр": "ХААН",
          "Дансны дугаар": "5031892952"
        },
      ],
      packet: [
        { title: "Ангилал", text: "" },
        { title: "Багцын дугаар", text: "" },
        { title: "Багцын хугацаа", text: "1 сар" },
        { title: "Бодлогын тоо", text: "105" },
        { title: "Нийт сорил", text: "3" },
      ],
      classify: [
        { text: "1-2-р анги" },
        { text: "" },
        { text: "3-4-р анги" },
        { text: "" },
        { text: "5-6-р анги" },
        { text: "" },
        { text: "7-8-р анги" },
        { text: "" },
        { text: "9-10-р анги" },
        { text: "" },
        { text: "11-12-р анги" },
        { text: "" },
      ],
    };
  },
  mounted() {
    this.packet[0].text = this.classify[this.reclass - 1].text;
    this.packet[1].text = this.repacket;
  },
};
</script>
<style scoped>
.pay-content {
  background-color: #ffff;
  font-family: "Roboto", sans-serif;
  padding: 40px 20px 40px 20px;
  max-width: 500px;
}

.bill-container {
  font-size: 1.2em;
}

.packet-pay {
  width: 100%;
  background-color: rgba(134, 179, 183, 0.1);
  border-radius: 10px;
  font-size: 1em;
  padding: 10px;
  margin: 5px 0px 30px 0px;
}
</style>
